import { createContext } from 'react';

const activeDeals = [];
const layout = [
    {
        width: 140,
        filterType: 'text',
        type: 'text',
        disabledField: false,
        disabledFilter: false,
        textContent: 'Deal',
        filterValue: 'Name',
        textValue: 'name',
    },
    {
        width: 150,
        filterType: 'text',
        type: 'object',
        disabledField: false,
        disabledFilter: false,
        textContent: 'Uppdragsgivare',
        filterValue: 'Customer',
        textValue: 'customer',
    },
    {
        width: 150,
        filterType: 'text',
        type: 'object',
        disabledField: false,
        disabledFilter: false,
        textContent: 'Kontaktperson',
        filterValue: 'Contact',
        textValue: 'contact',
    },
    {
        width: 125,
        filterType: 'select',
        type: 'list',
        disabledField: false,
        disabledFilter: true,
        textContent: 'Konsulter',
        filterValue: 'Consultants',
        textValue: 'consultants',
    },
    {
        width: 150,
        filterType: 'select',
        type: 'list',
        disabledField: false,
        disabledFilter: true,
        textContent: 'Underkonsulter',
        filterValue: 'UnderConsultants',
        textValue: 'underConsultants',
    },
    {
        width: 125,
        filterType: 'text',
        type: 'text',
        disabledField: false,
        disabledFilter: true,
        textContent: 'Startdatum',
        filterValue: 'StartDate',
        textValue: 'startDate',
    },
    {
        width: 200,
        filterType: 'text',
        type: 'text',
        disabledField: false,
        disabledFilter: true,
        textContent: 'Avtalsslut (exkl. option)',
        filterValue: 'EndDate',
        textValue: 'endDate',
    },

    {
        width: 100,
        filterType: 'text',
        type: 'text',
        disabledField: false, // Causes error int
        disabledFilter: false,
        textContent: 'Timpris',
        filterValue: 'HourRate',
        textValue: 'hourRate',
    },
    {
        width: 200,
        filterType: 'text',
        type: 'text',
        disabledField: false,
        disabledFilter: true,
        textContent: 'Timpris Marginal (UK)',
        filterValue: 'MarginalUk',
        textValue: 'marginRate',
    },
    {
        width: 150,
        filterType: 'text',
        type: 'text',
        disabledField: false,
        disabledFilter: false,
        textContent: 'Värde',
        filterValue: 'Value',
        textValue: 'value',
    },
];

export const initialState = {
    apiUrl: 'crmActiveDealsFront',
    layout: layout,
    activeDeals: activeDeals,
    rows: activeDeals,
    viewSettings: {
        minIndex: 0,
        maxIndex: 0,
        itemHeight: 40,
        totalHeight: 0,
        bufferHeight: 0,
        topPaddingHeight: 0,
        bottomPaddingHeight: 0,
        tolerance: 20,
    },
    requestObject: {
        startIndex: 0,
        amount: 30,
        tolerance: 20,
        filters: {},
    },
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'UPDATE_VIEW_SETTINGS_AND_REQUEST_OBJECT':
            return {
                ...state,
                viewSettings: action.viewSettings,
                requestObject: action.requestObject,
            };
        case 'UPDATE_VIEW_SETTINGS':
            return {
                ...state,
                viewSettings: action.viewSettings,
            };
        case 'UPDATE_REQUEST_OBJECT':
            return {
                ...state,
                requestObject: action.requestObject,
            };
        case 'UPDATE_DATA':
            return {
                ...state,
                activeDeals: action.payload,
                rows: action.payload,
            };
        default:
            return state;
    }
};

export const DataContext = createContext(initialState);
